var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{ref:"wrapper",attrs:{"type-list":"requests","item-source":_vm.fetchFriendRequests,"popover-position-target":_vm.popoverPositionTarget,"popover-items":_vm.items,"dummy-props":{
    headerText: _vm.$t(
      '_web_account-list_dummy_friends-requests',
      'You have no friendship requests at the moment'
    ),
    text: _vm.$t(
      '_web_account-list_dummy_friends-requests_subheader',
      'We believe that they will appear soon'
    ),
  }},on:{"hidePopover":function($event){_vm.popoverPositionTarget = null}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var user = ref.user;
return (!user.isHidden)?_c('ListItemAccount',_vm._b({key:user.login,staticClass:"mb-3 py-2 pl-5 pr-5"},'ListItemAccount',{
      type: user.type,
      avatar: user.avatar,
      name: _vm.$filters.displayName(user),
      accountId: user.login,
      approved: user.approved,
      vanityId: user.vanityId || user.vanity_id,
    },false),[(_vm.account._canEdit && _vm.myAccountId !== user.login)?_c('div',{staticClass:"d-flex align-items-center",attrs:{"slot":"action"},slot:"action"},[(_vm.hasAccessByPermission('addToFriend'))?_c('Btn',{staticClass:"h-mr-3 btn-secondary-simple",attrs:{"label":_vm.friendAcceptText(user),"loading":user.isLoading},on:{"click":function($event){$event.preventDefault();return _vm.friendAccept(user)}}}):_vm._e(),_c('ThreeDots',{staticClass:"cursor-pointer px-3 py-4",attrs:{"items":_vm.items},on:{"click":function (event) { return _vm.dotsClickHandler(event, user); }}})],1):_vm._e()]):_vm._e()}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }